import { render, staticRenderFns } from "./Brands.vue?vue&type=template&id=bdc71d36&scoped=true&"
import script from "./Brands.vue?vue&type=script&lang=ts&"
export * from "./Brands.vue?vue&type=script&lang=ts&"
import style0 from "./Brands.vue?vue&type=style&index=0&id=bdc71d36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdc71d36",
  null
  
)

export default component.exports